export default __webpack_public_path__ + "static/media/hm-logo.9d9a72ad.png";